// @ts-expect-error image import
import accountOverViewScreenshot from 'bender-url!../img/upgrade-modal/account-overview-screenshot.png'; // @ts-expect-error image import

import adSequencing from 'bender-url!../img/upgrade-modal/ad-sequencing.png'; // @ts-expect-error image import

import addOnWebsite from 'bender-url!../img/upgrade-modal/add-on-website.svg'; // @ts-expect-error image import

import adsAccountConnection from 'bender-url!../img/upgrade-modal/ads_account_connection.png'; // @ts-expect-error image import

import adsAttributionViews from 'bender-url!../img/upgrade-modal/ads_attribution_views.png'; // @ts-expect-error image import

import adsCalculateROI from 'bender-url!../img/upgrade-modal/ads_calculate_roi.png'; // @ts-expect-error image import

import adsContactList from 'bender-url!../img/upgrade-modal/ads_contact_list.png'; // @ts-expect-error image import

import adsCreateList from 'bender-url!../img/upgrade-modal/ads_create_list.png'; // @ts-expect-error image import

import adsCreateWebAudience from 'bender-url!../img/upgrade-modal/ads_create_web_audience.png'; // @ts-expect-error image import

import adsOfflineEventsV2 from 'bender-url!../img/upgrade-modal/ads_offline_events_v2.png'; // @ts-expect-error image import

import adsOfflineEvents from 'bender-url!../img/upgrade-modal/ads_offline_events.png'; // @ts-expect-error image import

import attibutionSidebarPQL from 'bender-url!../img/upgrade-modal/attribution-sidebar-pql.svg'; // @ts-expect-error image import

import audienceTargetingMarketingPro from 'bender-url!../img/upgrade-modal/audience_targeting_marketing_pro.svg'; // @ts-expect-error image import

import botsAndKnolwedge from 'bender-url!../img/upgrade-modal/bots_and_knowledge.png'; // @ts-expect-error image import

import botsAndMarketingPro from 'bender-url!../img/upgrade-modal/bots_and_marketing_pro.png'; // @ts-expect-error image import

import botsAndMeetings from 'bender-url!../img/upgrade-modal/bots_and_meetings.png'; // @ts-expect-error image import

import botsBookMeetings from 'bender-url!../img/upgrade-modal/bots_book_meetings.png'; // @ts-expect-error image import

import botsSupportBot from 'bender-url!../img/upgrade-modal/bots_support_bot.png'; // @ts-expect-error image import

import callActivityType from 'bender-url!../img/upgrade-modal/call-activity-types.svg'; // @ts-expect-error image import

import capacityLimits from 'bender-url!../img/upgrade-modal/capacity-limits.png'; // @ts-expect-error image import

import chatflowsBookMeetings from 'bender-url!../img/upgrade-modal/chatflows_book_meetings.png'; // @ts-expect-error image import

import contactsDedupe from 'bender-url!../img/upgrade-modal/contacts_dedupe.png'; // @ts-expect-error image import

import conversationAssignment from 'bender-url!../img/upgrade-modal/conversation-assignment.svg'; // @ts-expect-error image import

import crmRequiredProperties from 'bender-url!../img/upgrade-modal/crm_required_properties.svg'; // @ts-expect-error image import

import customCallOutcomes from 'bender-url!../img/upgrade-modal/custom-call-outcomes.png'; // @ts-expect-error image import

import customMeetingOutcome from 'bender-url!../img/upgrade-modal/custom-meeting-outcome.png'; // @ts-expect-error image import

import dealCreateAttributionUpgradePoint from 'bender-url!../img/upgrade-modal/deal-create-attribution-upgrade-point.png'; // @ts-expect-error image import

import dealLineItem from 'bender-url!../img/upgrade-modal/deal-line-item.png'; // @ts-expect-error image import

import doubleOptInEditUpgrade from 'bender-url!../img/upgrade-modal/double-opt-in-edit-upgrade.jpg'; // @ts-expect-error image import

import doubleOptInTurnOff from 'bender-url!../img/upgrade-modal/double-opt-in-turn-off.jpg'; // @ts-expect-error image import

import ecommerceEmailTemplates from 'bender-url!../img/upgrade-modal/ecommerce-email-templates.png'; // @ts-expect-error image import

import electronicSignature from 'bender-url!../img/upgrade-modal/electronic-signature.svg'; // @ts-expect-error image import

import emailABTest from 'bender-url!../img/upgrade-modal/email-ab-test.png'; // @ts-expect-error image import

import emailComparisonTool from 'bender-url!../img/upgrade-modal/email-comparison-tool.png'; // @ts-expect-error image import

import emailSaveTemplate from 'bender-url!../img/upgrade-modal/email-save-template.png'; // @ts-expect-error image import

import formsEnableLogicProperties from 'bender-url!../img/upgrade-modal/forms_enable_logic_properties.svg'; // @ts-expect-error image import

import formsRemoveBranding from 'bender-url!../img/upgrade-modal/forms_remove_branding.png'; // @ts-expect-error image import

import formsComparisonTool from 'bender-url!../img/upgrade-modal/forms-comparison-tool.png'; // @ts-expect-error image import

import formsCustomizeStyle from 'bender-url!../img/upgrade-modal/forms-customize-style.png'; // @ts-expect-error image import

import formsEmailDomainBlocking from 'bender-url!../img/upgrade-modal/forms-email-domain-blocking.png'; // @ts-expect-error image import

import hdsMarketingEnterprise from 'bender-url!../img/upgrade-modal/hds-marketing-enterprise.png'; // @ts-expect-error image import

import hdsMarketingPro from 'bender-url!../img/upgrade-modal/hds-marketing-pro.svg'; // @ts-expect-error image import

import leadflowsCustomFields from 'bender-url!../img/upgrade-modal/leadflows_custom_fields.svg'; // @ts-expect-error image import

import leadflowsEmailConnector from 'bender-url!../img/upgrade-modal/leadflows_email_connector.png'; // @ts-expect-error image import

import leadflowsOptIn from 'bender-url!../img/upgrade-modal/leadflows_opt_in.jpg'; // @ts-expect-error image import

import leadflowsRemoveBranding from 'bender-url!../img/upgrade-modal/leadflows_remove_branding.svg'; // @ts-expect-error image import

import leadflowsTargetingOptions from 'bender-url!../img/upgrade-modal/leadflows_targeting_options.jpg'; // @ts-expect-error image import

import linkedinSalesNavigator from 'bender-url!../img/upgrade-modal/linkedin_sales_navigator.svg'; // @ts-expect-error image import

import marketingProfessionalEmail from 'bender-url!../img/upgrade-modal/marketing-professional-email.svg'; // @ts-expect-error image import

import meetingsAutoBook from 'bender-url!../img/upgrade-modal/meetings-auto-book.svg'; // @ts-expect-error image import

import meetingsEmbed from 'bender-url!../img/upgrade-modal/meetings-embed.png'; // @ts-expect-error image import

import meetingsForms from 'bender-url!../img/upgrade-modal/meetings-forms.gif'; // @ts-expect-error image import

import meetingsRemoveBranding from 'bender-url!../img/upgrade-modal/meetings-remove-branding.gif'; // @ts-expect-error image import

import meetingsTeam from 'bender-url!../img/upgrade-modal/meetings-team.png'; // @ts-expect-error image import

import meetingsURlAnimated from 'bender-url!../img/upgrade-modal/meetings-url-animated.gif'; // @ts-expect-error image import

import multipleDealPipelines from 'bender-url!../img/upgrade-modal/multiple_deal_pipelines.svg'; // @ts-expect-error image import

import pagesABTest from 'bender-url!../img/upgrade-modal/pages-ab-test.png'; // @ts-expect-error image import

import pagesAdaptiveTest from 'bender-url!../img/upgrade-modal/pages-adaptive-test.png'; // @ts-expect-error image import

import productQuotesPQL from 'bender-url!../img/upgrade-modal/product-quotes-PQL.png'; // @ts-expect-error image import

import prospectingWorkspaceLeads from 'bender-url!../img/upgrade-modal/prospecting-workspace-leads.png'; // @ts-expect-error image import

import prospectingWorkspaceSchedule from 'bender-url!../img/upgrade-modal/prospecting-workspace-schedule.png'; // @ts-expect-error image import

import prospectingWorkspaceSummary from 'bender-url!../img/upgrade-modal/prospecting-workspace-summary.png'; // @ts-expect-error image import

import quotesEsignPQL from 'bender-url!../img/upgrade-modal/quotes-esign-PQL.png'; // @ts-expect-error image import

import revenueAttributionPQL from 'bender-url!../img/upgrade-modal/revenue-attribution-pql.svg'; // @ts-expect-error image import

import simpleWorkflow from 'bender-url!../img/upgrade-modal/simple-workflows.svg'; // @ts-expect-error image import

import starterWithEmail from 'bender-url!../img/upgrade-modal/starter-with-email.svg'; // @ts-expect-error image import

import successQuoteMet from 'bender-url!../img/upgrade-modal/success-quota-met.svg'; // @ts-expect-error image import

import svhProSlaTimeToClose from 'bender-url!../img/upgrade-modal/svh-pro-sla-time-to-close.svg'; // @ts-expect-error image import

import svhProSlaTimeToReply from 'bender-url!../img/upgrade-modal/svh-pro-sla-time-to-reply.svg'; // @ts-expect-error image import

import targetAccounts from 'bender-url!../img/upgrade-modal/target-accounts.png'; // @ts-expect-error image import

import taskQueues from 'bender-url!../img/upgrade-modal/task-queues.svg'; // @ts-expect-error image import

import team from 'bender-url!../img/upgrade-modal/team.svg'; // @ts-expect-error image import

import upgradeArrow from 'bender-url!../img/upgrade-modal/upgrade_arrow.svg'; // @ts-expect-error image import

import whatsAppMessaging from 'bender-url!../img/upgrade-modal/whatsapp-messaging.png';
/**
 * Key: file name
 *
 * Value: image file import
 */

export const modalImages = {
  'account-overview-screenshot.png': accountOverViewScreenshot,
  'ad-sequencing.png': adSequencing,
  'add-on-website.png': addOnWebsite,
  'ads_account_connection.png': adsAccountConnection,
  'ads_attribution_views.png': adsAttributionViews,
  'ads_calculate_roi.png': adsCalculateROI,
  'ads_contact_list.png': adsContactList,
  'ads_create_list.png': adsCreateList,
  'ads_create_web_audience.png': adsCreateWebAudience,
  'ads_offline_events_v2.png': adsOfflineEventsV2,
  'ads_offline_events.png': adsOfflineEvents,
  'attribution-sidebar-pql.svg': attibutionSidebarPQL,
  'audience_targeting_marketing_pro.png': audienceTargetingMarketingPro,
  'bots_and_knowledge.png': botsAndKnolwedge,
  'bots_and_marketing_pro.png': botsAndMarketingPro,
  'bots_and_meetings.png': botsAndMeetings,
  'bots_book_meetings.png': botsBookMeetings,
  'bots_support_bot.png': botsSupportBot,
  'call-activity-types.svg': callActivityType,
  'capacity-limits.png': capacityLimits,
  'chatflows_book_meetings.png': chatflowsBookMeetings,
  'contacts_dedupe.png': contactsDedupe,
  'conversation-assignment.svg': conversationAssignment,
  'crm_required_properties.svg': crmRequiredProperties,
  'custom-call-outcomes.png': customCallOutcomes,
  'custom-meeting-outcome.png': customMeetingOutcome,
  'deal-create-attribution-upgrade-point.png': dealCreateAttributionUpgradePoint,
  'deal-line-item.png': dealLineItem,
  'double-opt-in-edit-upgrade.jpg': doubleOptInEditUpgrade,
  'double-opt-in-turn-off.jpg': doubleOptInTurnOff,
  'ecommerce-email-templates.png': ecommerceEmailTemplates,
  'electronic-signature.svg': electronicSignature,
  'email-ab-test.png': emailABTest,
  'email-comparison-tool.png': emailComparisonTool,
  'email-save-template.png': emailSaveTemplate,
  'forms_enable_logic_properties.svg': formsEnableLogicProperties,
  'forms_remove_branding.png': formsRemoveBranding,
  'forms-comparison-tool.png': formsComparisonTool,
  'forms-customize-style.png': formsCustomizeStyle,
  'forms-email-domain-blocking.png': formsEmailDomainBlocking,
  'hds-marketing-enterprise.png': hdsMarketingEnterprise,
  'hds-marketing-pro.svg': hdsMarketingPro,
  'leadflows_custom_fields.svg': leadflowsCustomFields,
  'leadflows_email_connector.png': leadflowsEmailConnector,
  'leadflows_opt_in.jpg': leadflowsOptIn,
  'leadflows_remove_branding.svg': leadflowsRemoveBranding,
  'leadflows_targeting_options.jpg': leadflowsTargetingOptions,
  'linkedin_sales_navigator.svg': linkedinSalesNavigator,
  'marketing-professional-email.svg': marketingProfessionalEmail,
  'meetings-auto-book.svg': meetingsAutoBook,
  'meetings-embed.png': meetingsEmbed,
  'meetings-forms.gif': meetingsForms,
  'meetings-remove-branding.gif': meetingsRemoveBranding,
  'meetings-team.png': meetingsTeam,
  'meetings-url-animated.gif': meetingsURlAnimated,
  'multiple_deal_pipelines.svg': multipleDealPipelines,
  'pages-ab-test.png': pagesABTest,
  'pages-adaptive-test.png': pagesAdaptiveTest,
  'product-quotes-PQL.png': productQuotesPQL,
  'prospecting-workspace-leads.png': prospectingWorkspaceLeads,
  'prospecting-workspace-schedule.png': prospectingWorkspaceSchedule,
  'prospecting-workspace-summary.png': prospectingWorkspaceSummary,
  'quotes-esign-PQL.png': quotesEsignPQL,
  'revenue-attribution-pql.svg': revenueAttributionPQL,
  'simple-workflows.svg': simpleWorkflow,
  'starter-with-email.svg': starterWithEmail,
  'success-quota-met.svg': successQuoteMet,
  'svh-pro-sla-time-to-close.svg': svhProSlaTimeToClose,
  'svh-pro-sla-time-to-reply.svg': svhProSlaTimeToReply,
  'target-accounts.png': targetAccounts,
  'task-queues.svg': taskQueues,
  'team.svg': team,
  'upgrade_arrow.svg': upgradeArrow,
  'whatsapp-messaging.png': whatsAppMessaging
};
export const getUpgradePointImage = fileName => {
  if (!fileName || !modalImages[fileName]) {
    //todo: Add a fallback image
    return '';
  }

  return modalImages[fileName];
};